import FormatLink from "./formatLink";

const MultipleFormatsMap = (props) => {
  
  return (props.data.map((item) => <FormatLink updateItemPage={props.updateItemPage} key={item.id} data={item} />))
  
};

export default MultipleFormatsMap;